import React from 'react';

const MaterialDetailRightMenu = () => {
  return <></>;
};

export default MaterialDetailRightMenu;
